import React, { useState } from "react";

const Accordian = ({ title, desc, bgColor }) => {
	const [isActive, setIsActive] = useState(false);

	const handleAccordionClick = (e) => {
		setIsActive(e.target.checked && !isActive);
	};

	return (
		<div
			className={`collapse collapse-plus cursor-pointer rounded-none border-b border-troo-borderclr ${
				isActive
					? "text-troo-white collapse-open"
					: `${
							bgColor || "text-troo-secondary"
					  } text-troo-stateTertiary collapse-close`
			}`}
		>
			<input type="radio" name="accordian" onClick={handleAccordionClick} />
			<h6 className={`collapse-title font-medium px-3 md:px-7 ${isActive && "text-troo-secondary"}`}>{title}</h6>
			<div className="collapse-content px-7">
				<p>{desc}</p>
			</div>
		</div>
	);
};

export default Accordian;